class SortFactory {
  private sortData: object[]

  constructor(data: object[] = []) {
    this.sortData = data
  }

  sortServiceAsc(query: string) {
    const key: string = this.keyByQuery(query)
    this.sortData.map((item: any) => {
      item.sort((a: any, b: any) => {
        if (a[key] < b[key]) {
          return -1
        }
        if (a[key] > b[key]) {
          return 1
        }
        return 0

      })
      return item
    })
    return this.sortData
  }

  sortServiceDesc(query: string) {
    const key: string = this.keyByQuery(query)
    this.sortData.map((item: any) => {
      item.sort((a: any, b: any) => {
        if (a[key] < b[key]) {
          return 1
        }
        if (a[key] > b[key]) {
          return - 1
        }
        return 0

      })
      return item
    })
    return this.sortData
  }

  private keyByQuery(query: string) {
    switch (query) {
      case 'Property ID':
       return 'id'
      case 'Property Name':
        return 'name'
      case 'Country':
        return 'country'
      case 'City':
        return 'city'
      default:
        return ''
    }
  }

  filterByParam(query: string) {
    const tempData: object[] = []
    this.sortData.filter((item: any) => {
      if ((item.name && item.name.toLowerCase().includes(query.toLocaleLowerCase())) ||
          (item.country && item.country.toLowerCase().includes(query.toLocaleLowerCase())) ||
          (item.city && item.city.toLowerCase().includes(query.toLocaleLowerCase())) ||
          ((item.id && item.id.toLowerCase().includes(query.toLocaleLowerCase())))) {
        tempData.push(item)
      }
      return tempData
    })
    return tempData
  }

  filterByQueryAndParams(query: string, param: string) {
    const tempData: object[] = []
    this.sortData.filter((item: any) => {
      if ((item[param] && item[param].toLowerCase()
        .includes(query.toLocaleLowerCase()))) {
          tempData.push(item)
      }
      return tempData
    })
    return tempData
  }
}

export {
  SortFactory
}
